
































































































import { Component, Vue } from "vue-property-decorator";
import { campaignsService } from "../api/campaigns.api";
import { CampaignModel } from "../models/Campaign";
import { campaignsStore } from "../store/campaigns.store";
import { appStore } from "../store/stores";
import dayjs from "dayjs";
import { CampaignStatus } from "../enums/campaign.enum";

@Component
export default class CampaignSummary extends Vue {
  status = CampaignStatus;
  get campaign(): Partial<CampaignModel> | undefined {
    return (
      this.serverCampaign ?? campaignsStore.campaigns.find(campaign => campaign.id === this.$route.params.campaignId)
    );
  }

  get genre() {
    return appStore.genres.find(x => x.id === this.campaign?.song?.genreId);
  }

  get musicPlatform() {
    return appStore.musicPlatforms.find(x => x.id === this.campaign?.musicPlatformId);
  }

  get musicPlatformLink() {
    const song = this.campaign?.song;
    return song?.musicLinks.find(x => x.musicPlatformId === this.campaign?.musicPlatformId)?.link;
  }

  serverCampaign: Partial<CampaignModel> | null = null;

  mounted() {
    this.getCampaign();
  }

  async getCampaign() {
    try {
      this.showLoading();
      const response = await campaignsService.findOneByArtiste(this.$route.params.campaignId);
      this.serverCampaign = response.data;
    } catch (error) {
      this.handleError(error);
    } finally {
      this.hideLoading();
    }
  }
}
